import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Avatar, Button, TextField, Typography, IconButton } from "@material-ui/core";
import ForumIcon from "@material-ui/icons/Forum";
import SendIcon from "@material-ui/icons/Send";
import DeleteIcon from "@material-ui/icons/Delete";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import moment from "moment";
import blankProfile from "../../../img/hotgig-loading.png";
import ConfirmationModal from "../../modal/ConfirmationModal.js";
import "./BookingLineupCards.css";

@inject("lineupMessageStore", "templateStore", "profileStore")
@observer
class LineupMessage extends Component {
    state = {
        lineupMessageId: 0,
        lineUpMessageDeleteModal: false
    };

    componentDidMount() {
        this.props.templateStore.showLoadingScreen();
        this.props.lineupMessageStore.setBookingId(this.props.bookingId);
        this.props.lineupMessageStore.getBookingLineupMessages(this.props.bookingId).then(() => {
            this.props.templateStore.hideLoadingScreen();
        });
    }

    handleSendMesage = e => {
        this.props.templateStore.showLoadingScreen();
        this.props.lineupMessageStore.postBookingLineupMessage(this.props.bookingId).finally(() => {
            this.props.templateStore.hideLoadingScreen();
            this.props.templateStore.openSnackbar("Message sent!");
        });
    };

    handleChangeMessage = e => {
        this.props.lineupMessageStore.setMessage(e.target.value);
    };

    handleOpenModal = (id) => {
        this.setState({ lineupMessageId: id, lineUpMessageDeleteModal: true });
    };

    handleCloseModal = () => {
        this.setState({ lineupMessageId: 0, lineUpMessageDeleteModal: false });
    };

    handleDelete = () => {
        const { messages } = this.props.lineupMessageStore;
        this.props.lineupMessageStore.deleteLineupId(this.state.lineupMessageId).then(() => {
            var filteredMessages = messages.filter(x => x.id != this.state.lineupMessageId);
            this.props.lineupMessageStore.setMessages(filteredMessages);
            this.handleCloseModal();
        });
    };

    getInitials = (profile) => {
        if (!profile) return "?";
        const first = profile.firstName?.[0] || "";
        const last = profile.lastName?.[0] || "";
        return `${first}${last}`.toUpperCase();
    };

    formatTimeAgo = (dateString) => {
        return moment(dateString).fromNow();
    };

    render() {
        const { messages, message } = this.props.lineupMessageStore;
        const { currentProfile } = this.props.profileStore;

        return (
            <div className="lineup-messages-section">
                <div className="lineup-messages-card">
                    <div className="lineup-messages-header">
                        <ForumIcon className="lineup-messages-header-icon" />
                        <Typography variant="h6" className="lineup-messages-header-title">
                            Lineup Messages
                        </Typography>
                    </div>
                    <div className="lineup-messages-body">
                        {messages && messages.length > 0 ? (
                            <div className="lineup-messages-thread">
                                {messages.map((mess) => {
                                    const isMyMessage = mess.profileId === currentProfile?.id;
                                    const profileImage = mess.profileImageUrl || blankProfile;
                                    
                                    return (
                                        <div 
                                            key={mess.id} 
                                            className={`lineup-message-item ${isMyMessage ? 'mine' : ''}`}
                                        >
                                            <Avatar 
                                                src={profileImage}
                                                className="lineup-message-avatar"
                                            >
                                                {this.getInitials(mess.profile)}
                                            </Avatar>
                                            <div className="lineup-message-content">
                                                <div className="lineup-message-bubble">
                                                    {mess.message}
                                                </div>
                                                <div className="lineup-message-meta">
                                                    <span className="lineup-message-sender">
                                                        {isMyMessage ? "You" : mess.profile?.firstName || "Unknown"}
                                                    </span>
                                                    <span className="lineup-message-time">
                                                        {this.formatTimeAgo(mess.createdAt)}
                                                    </span>
                                                    {isMyMessage && (
                                                        <IconButton
                                                            className="lineup-message-delete"
                                                            onClick={() => this.handleOpenModal(mess.id)}
                                                            size="small"
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="lineup-messages-empty">
                                <ChatBubbleOutlineIcon className="lineup-messages-empty-icon" />
                                <Typography className="lineup-messages-empty-text">
                                    No messages yet. Start a conversation with your lineup!
                                </Typography>
                            </div>
                        )}

                        <div className="lineup-messages-compose">
                            <div className="lineup-messages-input">
                                <TextField
                                    id="lineup-message-body"
                                    placeholder="Type a message to your lineup..."
                                    multiline
                                    rows="3"
                                    variant="outlined"
                                    fullWidth
                                    value={message}
                                    onChange={this.handleChangeMessage}
                                />
                            </div>
                            <Button
                                variant="contained"
                                className="lineup-messages-send-btn"
                                onClick={() => this.handleSendMesage()}
                            >
                                <SendIcon />
                                Send
                            </Button>
                        </div>
                    </div>
                </div>

                <ConfirmationModal
                    open={this.state.lineUpMessageDeleteModal}
                    title="Delete Lineup Message"
                    message="Are you sure you want to delete this message?"
                    closeHandler={this.handleCloseModal}
                    confirmationHandler={() => this.handleDelete()}
                    declineHandler={this.handleCloseModal}
                    confirmationLabel="Delete"
                />
            </div>
        );
    }
}

export default LineupMessage;
